module.exports = ".mw-500 {\r\n  max-width: 500px;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main